import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { FooterThemesService } from "../../services/footer-themes.service";
import { tap } from "rxjs";
import { GET_FOOTER_CATEGORIES, GET_SITE_THEME, GET_SOCIALS, GET_STATIC_PAGES } from "./constants/constants";
import { FOOTER_CATEGORIES_LOADED_ACTION, SITE_THEME_LOADED_ACTION, SOCIALS_LOADED_ACTION, STATIC_PAGES_LOADED_ACTION } from "./FooterThemes.actions";
import { WebsiteAttributesService } from "imakeapp-shared";


@Injectable()
export class FooterEffect
{


  constructor(
    private store:Store,
    private actions$: Actions,
    private service: FooterThemesService,
    private webAttrService :WebsiteAttributesService
  ) {}



  get_footer_categories$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(GET_FOOTER_CATEGORIES),
            tap(
              (action: any)=>{

                this.service.get_footer_categories().subscribe(
                (response: any)=>{

                  this.store.dispatch(new FOOTER_CATEGORIES_LOADED_ACTION(response.data.categories));
                  // this.store.dispatch(new CATEGORIES_LOADED_ACTION(response.data.subCategories));

                },
                (err: any)=>{
                  console.error(err);
                })

              }
            )
          )
  },{dispatch:false});


  get_static_pages$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GET_STATIC_PAGES),
        tap(
          (action: any)=>{

            this.service.get_static_pages().subscribe(
              (response: any)=>{
                this.store.dispatch( new STATIC_PAGES_LOADED_ACTION(response) );
              },
              (err)=>{
                console.error(err);
              }
            );

          }
        )
      )
    },
    {
      dispatch:false
    }
  );



  get_socials$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GET_SOCIALS),
        tap(
          (action: any)=>{

            this.service.get_socials().subscribe(
              (response : any)=>{

                this.store.dispatch( new SOCIALS_LOADED_ACTION(response) );

              },
              (err)=>{
                console.error(err);
              }
            );


          }
        )
      )
    },
    {
      dispatch:false
    }
  );




  get_site_theme$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(GET_SITE_THEME),
        tap(
          (action: any)=>{

            this.webAttrService.get_site_attributes().subscribe(
              (response : any)=>{
console.log(response)
                this.store.dispatch( new SITE_THEME_LOADED_ACTION(response) );

              },
              (err)=>{
                console.error(err);
              }
            );


          }
        )
      )
    },
    {
      dispatch:false
    }
  );


}
